import { Steps } from './step';
import { Optional } from '../types/alias';

export const basicScenarioMap: Optional<Record<Steps, Marketing.AllScenarioType>> = {
  [Steps.WELCOME_MESSAGE]: 'WELCOME_REPLY',
  [Steps.AUTO_REPLY_ON_TIMEOUT]: 'TIMEOUT_REPLY',
  [Steps.PROMPT_ORDER]: 'ORDER_REMINDER',
  [Steps.PROMPT_PAYMENT]: 'PAYMENT_REMINDER',
  [Steps.PROMPT_POSITIVE_REVIEW]: 'PRAISE_REMINDER',
};

export const marketingScenarioMap: Optional<
  Record<Steps, Array<Marketing.AllScenarioType | Marketing.ExtendScenarioType>>
> = {
  [Steps.MARKETING_WELCOME]: ['WELCOME_REPLY', 'TIMEOUT_REPLY'],
};

export const aiSaleBotScenarioMap: Optional<Record<Steps, Marketing.AllScenarioType>> = {
  [Steps.PROMPT_ORDER]: 'ORDER_REMINDER',
  [Steps.PROMPT_PAYMENT]: 'PAYMENT_REMINDER',
  [Steps.PROMPT_POSITIVE_REVIEW]: 'PRAISE_REMINDER',
};

// 进阶配置场景配置
export const advancedScenarioMap: Optional<
  Record<Steps, Array<Marketing.AllScenarioType | Marketing.ExtendScenarioType>>
> = {
  [Steps.LOGISTICS_CARE]: ['CONFIRM_TRADE', 'DELIVERY_REMINDER', 'SIGN_REMINDER'],
  [Steps.ABANDONED_CART_RECOVERY]: [
    'RETURN_TRADE_ITEM_MISSING',
    'CANCELLING_TRADE_MODIFY_ORDER_AND_ADDRESS',
    'CANCELLING_TRADE_OTHERS_AND_CHANGE_MIND',
    'CANCELLING_DELIVERY_FAIL',
    'RETURN_TRADE_PRODUCT_NOT_IN_TIME_AND_NOT_RECEIPT',
    'CANCELLING_TRADE_MODIFY_ORDER_AND_PAY_AND_ADDRESS',
    'CANCELLING_TRADE_OTHERS',
    'CANCELLING_TRADE_LONG_TIME_UNSHIPPED',
    'RETURN_TRADE_NOT_RECEIPT',
    'CANCELLING_TRADE_WRONG_ORDER',
    'CANCELLING_TRADE_FOUND_CHEAPER_AND_DISCOUNT_WORSE',
  ],
  [Steps.REVIEW_MANAGEMENT]: ['POSITIVE_REVIEW_CARE', 'NEGATIVE_REVIEW_SAVE'],
};

export const scenarioMap: Optional<
  Record<
    Steps,
    Marketing.AllScenarioType | Array<Marketing.AllScenarioType | Marketing.ExtendScenarioType>
  >
> = {
  ...basicScenarioMap,
  ...advancedScenarioMap,
  ...marketingScenarioMap,
};

export function arrayScenario(
  scenario?:
    | Marketing.AllScenarioType
    | Array<Marketing.AllScenarioType | Marketing.ExtendScenarioType>,
): Array<Marketing.AllScenarioType | Marketing.ExtendScenarioType> {
  if (typeof scenario === 'undefined') {
    return [];
  }
  if (Array.isArray(scenario)) {
    return scenario;
  }
  return [scenario];
}

export const getStepNamesByScenario = (scenario: string[] | undefined) => {
  const scenarios = arrayScenario(scenario as Marketing.AllScenarioType | undefined);
  return [
    ...new Set(
      Object.entries(scenarioMap)
        .filter(([_, value]) => {
          const values = Array.isArray(value) ? value : [value];
          return values.every((value) => scenarios.includes(value));
        })
        .map(([key, _]) => key),
    ),
  ] as Steps[];
};
